import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FloatingContainer from "../common/container/floatingContainer";

import StaticContent from "./static";
import ExternalContent from "./external";
import GlobalPage from "./global-page";

import {
    hideContent
} from "src/shared_modules/veu-visitors-core/actions/content";

import {
    showPageGlobal,
    hidePageGlobal
} from "src/shared_modules/veu-visitors-core/actions/pages";


import { withMatomo } from 'src/shared_modules/veu-visitors-core/components/common/matomo-tracking';

import "./content.css";

class ContentView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading : true,
        }
    }

    componentDidMount() {
        this.handleClose = this.handleClose.bind(this);

        this.setState({isLoading: false });
    }

    componentDidUpdate(prevProps,prevState) {
        // TODO statistic here!!!
        if( this.state.isLoading )
        	return;

        if( prevProps.content !== this.props.content ) {

            let action = "hide";
            let category = "";
            let name = "";

            if( this.props.content.isOpen )
            {
                category = this.props.content.type +"-content";
                action = "show";
                name = this.props.content.url;
            }

            if( !this.props.content.isOpen && prevProps.content ) {
                category = prevProps.content.type +"-content";
                name = prevProps.content.url;
            }
            if( name !== null ) {
                // prevents spamming!
                this.props.trackEvent(category,action,name);
            }
        }

    }

    handleClose(){
        this.props.hidePageGlobal();
        this.props.hideContent();
    }

    render() {
        if( this.state.isLoading )
            return (null);

        if( !this.props.content.isOpen && !this.props.isGlobalOpen )
            return (null);

        let isStatic = (this.props.content.type === "static");
        let isExternal = (this.props.content.type === "external");

        return (<FloatingContainer hideBackdrop={true}
                        className="content"
                        heightFixed
                        position="center"
                        width={this.props.content.size}
                        fsSwitch="md"
                        onCloseButton={ this.handleClose }
                        largeBottomPadding={this.props.event.hasUserlike}
                    >
                    {isStatic && <StaticContent url={this.props.content.url}/>}
                    {isExternal && <ExternalContent url={this.props.content.url}/>}
                    {this.props.isGlobalOpen  && <GlobalPage /> }
                    { /* add more options here */}
            </FloatingContainer>);
    }
}

/*
 * ---------------------------------------------------------------------
 * prop Types
 * ---------------------------------------------------------------------
 */
ContentView.propTypes = {
    event: PropTypes.object,
    content: PropTypes.object,
    isGlobalOpen: PropTypes.bool,
    pageGlobal: PropTypes.object,

};

/*
 * ---------------------------------------------------------------------
 * ContentView Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = ( state, ownProps ) => {
    return {
        event: state.event,
        // static and external content
        content: state.content,
        // dynamic global pages
        isGlobalOpen: state.pages.isGlobalOpen,
        pageGlobal: state.pages.pageGlobal,
    };
};

const mapDispatchToProps = {
    hideContent,
    showPageGlobal,
    hidePageGlobal
};
 /*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(withMatomo(ContentView));
